var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"innerNav"},[_c('div',{staticClass:"title"},[_vm._v("ออเดอร์")]),_c('div',{staticClass:"searchIcon",on:{"click":function($event){return _vm.$router.push('/search/order')}}},[_c('img',{attrs:{"src":require("@/assets/img/search-gray.svg")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }